// What a container's part row asks (PartIntent: move it, take it out) onto
// the Studio's commands, each with its Undo (useStudioCommands.ts). Shared
// by the Studio's pages and the classic canvas. Opening is the caller's.

export { runPartIntent };

import { exhaustSwitchCase } from "@bilda/utils";
import type { PartIntent } from "../../../components/ModuleCard/partOps.js";
import type { ContainerCard } from "../../../components/Studio/studioCards.js";
import type { StudioCommands } from "../useStudioCommands.js";

const runPartIntent =
    (studio: Pick<StudioCommands, "movePart" | "removePart">) =>
    (container: ContainerCard, intent: PartIntent): void => {
        switch (intent.type) {
            // Opened by the view itself.
            case "open":
                return;
            case "move":
                studio.movePart(
                    container.id,
                    intent.part,
                    intent.from,
                    intent.to,
                );
                return;
            case "remove":
                studio.removePart(
                    container.id,
                    container.kind,
                    intent.part,
                    intent.at,
                );
                return;
            default:
                exhaustSwitchCase(intent);
        }
    };
